// src/components/VictoryOverlay.js
import { useEffect } from 'react';
import confetti from 'canvas-confetti';

function VictoryOverlay() {
  useEffect(() => {
    confetti({
      particleCount: 150,
      spread: 100,
      origin: { y: 0.6 },
    });
  }, []);

  return null; // No DOM rendered
}

export default VictoryOverlay;

  /* return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        zIndex: 999,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end', // ✅ push message to bottom
        alignItems: 'center',
        paddingBottom: '2rem',
        backgroundColor: 'transparent', // ✅ no shadow over puzzle
      }}
    >
      <div
        style={{
          backgroundColor: '#fff', // ✅ clean white box
          padding: '1rem 2rem',
          borderRadius: '8px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
          fontFamily: fontStyle,
          fontSize: '1.5rem',
          color: '#000', // ✅ black text
          maxWidth: '80%',
          textAlign: 'center',
          whiteSpace: 'pre-line',
        }}
      >
        {message}
      </div>
    </div>
  );
}

export default VictoryOverlay; */
